import { Options,ChangeContext } from '@angular-slider/ngx-slider';
import { Component, OnInit, ViewChild } from '@angular/core';
import { SectionEditorStoreService } from '../section-editor-dialog/section-editor-store.service';
import { NbPopoverDirective } from '@nebular/theme';

@Component({
  selector: 'kve-slider-popover',
  templateUrl: './slider-popover.component.html',
  styleUrls: ['./slider-popover.component.scss']
})
export class SliderPopoverComponent implements OnInit {
  currentValue;
  target;
  height;
  title:string;
  marginBottom;
  value:number;
  options: Options = {
    floor: 0,
    ceil: 40,
    step:8
  };

  @ViewChild(NbPopoverDirective) popover: NbPopoverDirective;
  
  constructor(private sectionEditorStoreService:SectionEditorStoreService) { }

  ngOnInit(): void {
    this.value = this.marginBottom;
  }

  onUserChange(changeContext: ChangeContext){
    console.log(changeContext.value);
    this.marginBottom = changeContext.value;
  }
  onUserChangeStart(changeContext: ChangeContext){

  }

  onUserChangeEnd(changeContext: ChangeContext){

  }

  onSubmit(){
    this.sectionEditorStoreService.updateMarginBottom(this.marginBottom);
  }

}
